import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./router/router";
import ignoreRoutes from "./router/ignoreRouter";
import store from "./store/";
import { routerMode, XAUTHTOKEN } from "./config/env";
import { Calendar } from "vant";
import "./config/rem";
import i18n from './i18n'
// 日历控件
// import $ from 'jquery'
import "./assets/css/calendar.css";
import "./assets/css/style.css";
import "./assets/js/date";
import Meta from "vue-meta";
// slide滑块组件
import "./assets/css/jquery.range.css";
import "./assets/js/jquery.range";

// fastclick插件
// import FastClick from 'fastclick'
import utils from "./utils.js"; // 获取url参数
// import iscroll from 'iscroll'
import {
  E_BEFORE_LOGIN_URL_EXHIBITION_NEW
  // CURRENTPAGE,
  // LANDINGPAGE
} from "./store/mutation-types.js";
// import {
//   weChatRedirectUrl,
//   mainrouterpath
// } from './config/env'
import VueHtml5Editor from "vue-html5-editor";
import editorOptions from "./plugins/editor";
import { zhTran } from "./plugins/zh";
import filter from "./plugins/name.filter";
import "babel-polyfill";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// HappyScroll
import { HappyScroll } from "vue-happy-scroll";
// 引入css
import "vue-happy-scroll/docs/happy-scroll.css";
import iView, { RETURN } from "iview";
import "iview/dist/styles/iview.css";

import Vant from "vant";
import "vant/lib/index.css";

// import "vant/lib/vant-css/index.css";

import _glob from "./page/hotel/methodCommon";
import MuseUI from "muse-ui";
import "muse-ui/dist/muse-ui.css";
import "muse-ui/dist/theme-light.css";
import Mint from "mint-ui";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

import toastRegistry from "./components/toast/index";
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";

import infiniteScroll from "vue-infinite-scroll";
import { Toast } from "vant";
// v2
import "@/assets/js/IsIphoneX";
import api from "./api"; // 将api挂载到vue的原型上

// import * as echarts from 'echarts';

import VCharts from "v-charts";

import VueCanvasPoster from "vue-canvas-poster";
import { GetRequest } from "./store/urlRequestParam.js";
import { render } from "less";
import MintUI from "mint-ui";
import "mint-ui/lib/style.css";


import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
// 引入 vConsole 调试工具
import VConsole from 'vconsole';

// 初始化 vConsole

if (process.env.NODE_ENV !== 'production') {
  const vConsole = new VConsole();
  console.log('vConsole 已启动，可以查看移动端日志');
}


Vue.use(VideoPlayer)

Vue.use(MintUI);

// Vue.prototype.$toast = Toast;//全局注册
// vant
Vue.use(Meta);
Vue.use(Vant);
Vue.use(Toast); // 导入api接口
// Vue.use(Dialog);
Vue.prototype.$api = api;
Vue.use(VCharts);
// 这里也可以直接执行 toastRegistry()
Vue.use(toastRegistry);
Vue.use(preview);
Vue.use(VueCanvasPoster);
// Vue.prototype.$echarts = echarts
// eleme
// Vue.use(ElementUI);
Vue.use(ElementUI, {
  size: "small",
  zIndex: 3000
});

Vue.use(infiniteScroll);
// 自定义组件名
Vue.component("happy-scroll", HappyScroll);

Vue.prototype.$eventBus = new Vue(); // eventbus通知
Vue.config.ignoredElements = ["wx-open-launch-weapp"];

// IView
Vue.use(iView);

Vue.prototype.$EventBus = new Vue(); // 全局的事件总线
Vue.prototype.glob = _glob;

var currencyType = localStorage.getItem("currency_type");
if (!currencyType || !currencyType.length) {
  localStorage.setItem("currency_type", "CNY");
}
Vue.filter("formatter_price", num => {
  if (!num) return "0.00";

  num = num.toString().replace(/[^\d\.-]/g, ""); // 转成字符串并去掉其中除数字, . 和 - 之外的其它字符。
  if (isNaN(num)) num = "0"; // 是否非数字值
  var sign = num == (num = Math.abs(num));
  num = Math.floor(num * 100 + 0.50000000001); // 下舍入
  var cents = num % 100; // 求余 余数 = 被除数 - 除数 * 商
  cents = cents < 10 ? "0" + cents : cents; // 小于2位数就补齐
  num = Math.floor(num / 100).toString();
  for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
    // 每隔三位小数分始开隔
    // 4 ==> 三位小数加一个分隔符，
    num =
      num.substring(0, num.length - (4 * i + 3)) +
      "," +
      num.substring(num.length - (4 * i + 3));
  }
  return (sign ? "" : "-") + num + "." + cents;
});

Vue.use(MuseUI);
Vue.use(Mint);
// if ('addEventListener' in document) {
//   document.addEventListener('DOMContentLoaded', function() {
//     FastClick.attach(document.body);
//   }, false);
// }

// swiper
Vue.use(VueAwesomeSwiper);

Vue.prototype.$utils = utils; // 注册全局方法
// Vue.prototype.$iscroll = iscroll
/*
  如果你使用了JQuery，那么JS引入就可以改用下面的写法：
  $(function() {
    FastClick.attach(document.body);
  });
  如果你使用Browserify或者其他CommonJS-style 系统,当你调用`require('fastclick')`时，`FastClick.attach`事件会被返回，
  加载FastClick最简单的方式就是下面的方法了：
  var attachFastClick = require('fastclick');
  attachFastClick(document.body);
*/
// Vue.use(VueHtml5Editor, lookOptions);
localStorage.removeItem("lang");
// 判断浏览器的系统语言
// currencyType = localStorage.getItem('currency_type')
var language = (navigator.language || navigator.browserLanguage).toLowerCase();
console.log("语言:"+navigator.language );

var lang = localStorage.getItem("lang");
console.log(language.indexOf("zh-cn") > -1);


if (language.indexOf("zh-cn") > -1) {
  if (!lang || lang.length === 0) {
    localStorage.setItem("lang", "s");
    localStorage.setItem("currency_type", "CNY");
  }
} else {
  if (!lang || lang.length === 0) {
    localStorage.setItem("lang", "t");

    localStorage.setItem("currency_type", "MOP");
  }
}
console.log("zh=====" + language);

Vue.use(VueHtml5Editor, editorOptions);
Vue.filter("cut", (value, num) => {
  return filter.nameLong(value, num);
});
Vue.filter("tname", value => {
  return filter.nameFilter(value);
});
Vue.filter("trans", value => {
  return zhTran(value, localStorage.getItem("lang"));
});
Vue.filter("timeToMin", value => {
  return zhTran(filter.timeFormat(value), localStorage.getItem("lang"));
});
Vue.directive("qaload-more", {
  bind: (el, binding) => {
    el.addEventListener(
      "touchmove",
      () => {
        if (
          document.body.scrollHeight - 30 <=
          screen.height + document.body.scrollTop
        ) {
          binding.value();
        }
      },
      false
    );
  }
});
Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  mode: routerMode,
  strict: process.env.NODE_ENV !== "production"
});

router.beforeEach((to, from, next) => {
  console.log("url to================" + to.fullPath);

  // 根据url后面的参数设置语言start
  console.log(utils.getUrlKey("lang"));
  document.title =
    localStorage.getItem("lang") == "s"
      ? "发现澳门FindMacau"
      : "發現澳門FindMacau";

  //当前判断主要通过分享渠道进入Page页面执行该方法
  if (utils.getUrlKey("lang") === "s") {
    localStorage.setItem("lang", "s");
    // localStorage.setItem("currency_type", "CNY");
    Vue.filter("trans", value => {
      return zhTran(value, localStorage.getItem("lang"));
    });
  } else if (utils.getUrlKey("lang") === "t") {
    localStorage.setItem("lang", "t");

    // localStorage.setItem("currency_type", "MOP");
    Vue.filter("trans", value => {
      return zhTran(value, localStorage.getItem("lang"));
    });
  }

  //当前判断主要通过分享渠道进入Page页面执行该方法
  if (utils.getUrlKey("currency_type") === "CNY") {
    localStorage.setItem("currency_type", "CNY");
  } else if (utils.getUrlKey("currency_type") === "MOP") {
    localStorage.setItem("currency_type", "MOP");
  } else if (utils.getUrlKey("currency_type") === "HKD") {
    localStorage.setItem("currency_type", "HKD");
  } else if (utils.getUrlKey("currency_type") === "TWD") {
    localStorage.setItem("currency_type", "TWD");
  }
  // 根据url后面的参数设置语言end

  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );

  console.log("手机端");
  if (!flag) {

    if (
      location.href.indexOf("FMapplicationform") != -1 ||
      location.href.indexOf("vote") != -1 ||
      location.href.indexOf("merchantJoin") != -1 ||
      location.href.indexOf("staffJoin") != -1 ||
      location.href.indexOf("join") != -1 ||
      location.href.indexOf("voteresult") != -1 ||
         (location.href.indexOf("orderPayFinished") != -1 && utils.getUrlKey("boc_alipay_xcx") == "1")
    ) {
      next();
    } else {
      var orginUrl = "";
      if (process.env.NODE_ENV == "development") {
        orginUrl =  window.location.origin + "/";
      } else if (process.env.NODE_ENV == "uat") {
        orginUrl = "https://uatpc.findmacau.com/";
      } else {
        orginUrl = "https://findmacau.com/";
      }
      if (location.pathname == "/PaySuccessViewController") {
        var is_macau_water_run = utils.getUrlKey("is_macau_water_run");
        var trade_id = utils.getUrlKey("trade_id");
        var activity_category_id = utils.getUrlKey("activity_category_id");

        if (is_macau_water_run == 1) {

          window.location.replace('https://macaowaterrun.com/PaySuccessViewController?trade_id=' + trade_id + '&activity_category_id=' + activity_category_id);

        } else {
          var currentUrl = location.origin + "/";
          if (currentUrl != orginUrl) {
            location.href = orginUrl;
          }
        }

      } else if (location.pathname == "/commodityItem") {
        //商品详情
        var commodityid = utils.getUrlKey("commodityid");
        if (commodityid) {
          location.href = orginUrl + "order?commodityid=" + commodityid;
        }
      } else if (location.pathname == "Webview") {
        var content_url = utils.getUrlKey("content_url");
        var is_movies = utils.getUrlKey("is_movies");
        var title = utils.getUrlKey("title");
        if (content_url) {
          location.href =
            orginUrl +
            "webview?isGuide=" +
            true +
            "&content_url=" +
            content_url +
            "&is_movies=" +
            is_movies +
            "&title=" +
            title;
        }
      } else if (location.pathname == "/activitydetail") {
        var activity_id = utils.getUrlKey("activity_id");
        var title = utils.getUrlKey("title");
        if (activity_id) {
          location.href =
            orginUrl +
            "activityDetail?editor=" +
            "0" +
            "&activity_id=" +
            activity_id;
        }
      } else if (location.pathname === '/orderSubmitDirect') {
        location.href =
          orginUrl + "SeckillPayOrderView"


      } else {
        if (location.origin + "/" != orginUrl) {
          location.href = orginUrl;
        }
      }
    }
  } else {
    if (location.href.indexOf("appDownload") != -1) {
      next();
    } else {
      var orginUrl = "";
      if (process.env.NODE_ENV == "development") {
        orginUrl =  window.location.origin + "/";
      } else if (process.env.NODE_ENV == "uat") {
        orginUrl = "https://uatweb.findmacau.com/";
      } else {
        orginUrl = "https://web.findmacau.com/";
      }
      if (location.pathname == "/PaySuccessViewController") {
        var is_macau_water_run = utils.getUrlKey("is_macau_water_run");
        var trade_id = utils.getUrlKey("trade_id");
        var activity_category_id = utils.getUrlKey("activity_category_id");

        if (is_macau_water_run == 1) {

          if (process.env.NODE_ENV !== 'production') {
            window.location.replace('https://macaowaterrun.sinokru.com/PaySuccessViewController?trade_id=' + trade_id + '&activity_category_id=' + activity_category_id);

          } else {
            window.location.replace('https://macaowaterrun.com/PaySuccessViewController?trade_id=' + trade_id + '&activity_category_id=' + activity_category_id);
          }

        } else {
          var currentUrl = location.origin + "/";
          if (currentUrl != orginUrl) {
            location.href = orginUrl;
          }
        }

      } else if (location.pathname == "/order") {
        //商品详情
        var commodityid = utils.getUrlKey("commodityid");
        if (commodityid) {
          location.href = orginUrl + "commodityItem?commodityid=" + commodityid;
        }
      } else if (location.pathname == "/webview") {
        var content_url = utils.getUrlKey("content_url");
        var is_movies = utils.getUrlKey("is_movies");
        var isMobile = utils.getUrlKey("isMobile");
        var title = utils.getUrlKey("title");
        if (content_url && isMobile != 1) {
          location.href =
            orginUrl +
            "webview?content_url=" +
            content_url +
            "&is_movies=" +
            is_movies +
            "&isMobile=" +
            isMobile +
            "&title=" +
            title;
        }
      } else if (location.pathname == "/activityDetail") {
        var activity_id = utils.getUrlKey("activity_id");
        if (activity_id) {
          location.href =
            orginUrl + "activitydetail?activity_id=" + activity_id;
        }
      } else if (location.pathname === '/SeckillPayOrderView') {
        location.href =
          orginUrl + "orderSubmitDirect"


      } else {
        var currentUrl = location.origin + "/";
        if (currentUrl != orginUrl) {
          location.href = orginUrl;
        }
      }
    }

    //跳转任何页面 如果本地没有token都调用APP获取 token
    // 注意：只在URL明确提供token参数时才更新，避免覆盖已存在的登录态
    if (utils.getUrlKey("token") !== null) {  //明确检查参数是否存在
      if (utils.getUrlKey("token").length > 0) {
        // URL中有有效token，更新本地存储
        window.localStorage.setItem(XAUTHTOKEN, utils.getUrlKey("token"));
        console.log("从URL参数更新token");
      } else {
        // URL中token参数为空，不覆盖已存在的token
        console.log("URL中token参数为空，保持现有登录态");
        
      }
    }
    // 如果没有token参数，保持现有的localStorage状态不变
    // console.log(to.path);
    if (~ignoreRoutes.indexOf(to.path) || ~to.path.indexOf("/myQA")) {
      sessionStorage.setItem("QUESTIONPART_URL", to.fullPath);
    }
    console.log(
      "baocunde URL为" +
      sessionStorage.getItem(E_BEFORE_LOGIN_URL_EXHIBITION_NEW)
    );
    console.log("to", to, "from", from);
    // 访问author 有token
    if (to.path === "/author" && localStorage.getItem(XAUTHTOKEN)) {
      console.log("you token fangwen author");
      if (from.path === "/answer" || from.path === "seeQ") {
        next(
          sessionStorage.getItem("QUESTIONPART_URL")
            ? sessionStorage.getItem("QUESTIONPART_URL")
            : "/question"
        );
        return;
      }

      console.log(from.fullPath, from.path, "=========");
      if (from.fullPath) {
        next(from.fullPath);
        return;
      } else {
        console.log("=====你去哪啊 啊  ====");
        next("/home");
        return;
      }
    }


    // 记录当前访问的页面路径，用于登录后跳转
    if (to.path === "/home" || to.path === "/shopping" || to.path === "/citythings" || to.path === "/my") {
      window.sessionStorage.setItem('E_BEFORE_LOGIN_URL_EXHIBITION_NEW', window.location.origin + to.path);
    }
    next();
  }
});

Vue.prototype.goBeforeLoginUrl = () => {

  // var urllocal = localStorage.getItem('E_BEFORE_LOGIN_URL_EXHIBITION_NEW');
  var url = window.sessionStorage.getItem("E_BEFORE_LOGIN_URL_EXHIBITION_NEW");
  console.log("local保存的url位" + url);
  if (!url || url.indexOf("/author") !== -1) {
    router.replace("/home");
  } else {
    if (url.indexOf("orderOptionNext") != -1) {
      router.go(-2);
    } else
      window.location.href = url;


  }
};

Vue.prototype.goSeeQuestionUrl = () => {
  let url = sessionStorage.getItem("QUESTIONPART_URL");
  // console.log('session保存的url位'+url);
  if (!url || url.indexOf("/author") !== -1) {
    // url不存在 或者 访问author
    router.push("/question");
    sessionStorage.removeItem("QUESTIONPART_URL");
  } else {
    router.replace(url);
  }
};

new Vue({
  data: {
    currentRoute: window.location.pathname
  },
i18n,
  router,
  store
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js